<template >
  <div>
    <div class="list-group">
      <v-card tile height="100vh" max-height="calc(100% - 86px)" width="240" class="rounded-0 elevation-0">
        <div class="list-group-title"></div>

        <v-navigation-drawer permanent>
          <v-list-item-group color="var(--app-dark-blue-1)" v-model="selectedTicker" style="top: 8px">
            <v-list-item dense :key="index" style="height: 48px" v-for="(item, index) in items">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-navigation-drawer>
      </v-card>
    </div>
    <div class="component" v-if="typeof selectedTicker == 'number'">
      <component v-bind:is="items[selectedTicker].content"></component>
    </div>
  </div>
</template>

<script>
import AppealUsers from "@/views/Appeal/AppealUsers";
import SupportsAppeal from "@/views/Appeal/SupportsAppeal";
import SocialsAppeal from "@/views/Appeal/SocialsAppeal";
import Links from "@/views/Appeal/Links";

export default {
  components: {
    AppealUsers,
    SupportsAppeal,
    SocialsAppeal,
    Links,
  },

  data: () => ({
    selectedTicker: 0,
    items: [
      {
        title: "Обращения",
        content: "AppealUsers",
      },
      {
        title: "Тех. поддержка",
        content: "SupportsAppeal",
      },
      {
        title: "Соц. сети",
        content: "SocialsAppeal",
      },
      {
        title: "Ссылки",
        content: "Links",
      },
    ],
  }),

  created() {
    if (this.$route.params.selectedTicker) {
      this.selectedTicker = this.$route.params.selectedTicker;
    }
  },

  methods: {},
  watch: {},
};
</script>
<style scoped>
.v-list-item__title {
  font-size: 1rem;
}

.list-group {
  position: fixed;
  display: block;
  margin: 0;
  padding: 0;
  width: 240px;
  max-width: 240px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;

  color: #f8f8f8;
}

.component {
  position: absolute;
  left: 240px;
  width: calc(100% - 240px);
}

.list-group-title {
  font-size: 28px;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 20px;
  padding-left: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
